import { Box, Flex, Text, VStack } from '@chakra-ui/react'
import { LuCircleStop as CircleStop, LuCrosshair as Crosshair } from 'react-icons/lu'
import SectionCard from './SectionCard'
import { themeColors, brand } from '../../../../theme'
import { parseUtcDate } from '../../../../lib/dates'
import { formatDuration, type Stop } from '../../../../lib/trackAnalytics'

const colors = themeColors

function clock(iso: string): string {
  return parseUtcDate(iso).toLocaleTimeString('es-PE', { hour: '2-digit', minute: '2-digit' })
}

interface Props {
  stops: Stop[]
  onFocusStop: (stop: Stop) => void
  delay?: number
}

export default function StopsList({ stops, onFocusStop, delay = 0 }: Props) {
  return (
    <SectionCard
      title="Paradas detectadas"
      subtitle={`${stops.length} en el recorrido`}
      icon={CircleStop}
      accent="#c8442f"
      delay={delay}
    >
      {stops.length === 0 ? (
        <Flex direction="column" align="center" justify="center" py={8} gap={2}>
          <CircleStop size={28} color={colors.textDimmed} />
          <Text fontSize="sm" color={colors.textMuted} textAlign="center">
            Sin paradas detectadas con los umbrales actuales
          </Text>
        </Flex>
      ) : (
        <VStack gap={2} alignItems="stretch" maxH="320px" overflowY="auto">
          {stops.map((stop, i) => (
            <Flex
              key={`${stop.startIndex}-${stop.endIndex}`}
              alignItems="center"
              gap={3}
              p={3}
              borderRadius="xl"
              border="1px solid"
              borderColor={colors.border}
              bg={colors.bgPanel}
              _hover={{ borderColor: brand.green }}
              transition="all 0.15s"
            >
              <Flex
                align="center"
                justify="center"
                w="28px"
                h="28px"
                borderRadius="full"
                bg="#c8442f18"
                color="#c8442f"
                fontSize="xs"
                fontWeight="bold"
                flexShrink={0}
              >
                {i + 1}
              </Flex>
              <Box flex="1" minW={0}>
                <Text fontSize="sm" fontWeight="700" color={colors.text}>
                  {formatDuration(stop.durationMs)}
                </Text>
                <Text fontSize="11px" color={colors.textMuted}>
                  {clock(stop.startAt)} – {clock(stop.endAt)} · {stop.pointCount} pts
                </Text>
              </Box>
              <Box
                as="button"
                p={2}
                borderRadius="lg"
                cursor="pointer"
                color={colors.textMuted}
                _hover={{ bg: colors.bgHover, color: brand.green }}
                transition="all 0.15s"
                title="Centrar en el mapa"
                onClick={() => onFocusStop(stop)}
              >
                <Crosshair size={16} />
              </Box>
            </Flex>
          ))}
        </VStack>
      )}
    </SectionCard>
  )
}
